import { StyleSheet } from 'aphrodite';
import { inputBorderColor } from '../../styles/colors';

/**
 * Shared styles for UserFilters component
 *
 * These styles are used across both admin and end-user management pages
 * to ensure consistent filter UI appearance and behavior.
 */
export const userFiltersStyles = StyleSheet.create({
	/**
	 * Container for the entire filter section with gray background
	 */
	filtersContainer: {
		backgroundColor: '#f8f9fa',
		borderRadius: 8,
		marginBottom: 20,
		padding: 16,
	},

	/**
	 * Horizontal row that contains all filter controls
	 */
	filterRow: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: 20,
	},

	/**
	 * Individual filter group (label + control)
	 */
	filterGroup: {
		alignItems: 'center',
		display: 'flex',
		gap: 8,
	},

	/**
	 * Label text for filter controls
	 */
	filterLabel: {
		color: '#4a4a4a',
		fontSize: 14,
		fontWeight: 500,
		minWidth: 'max-content',
	},

	/**
	 * Dropdown anchor styling
	 */
	dropdownAnchor: {
		borderColor: inputBorderColor,
		borderRadius: 8,
		borderStyle: 'solid',
		borderWidth: 1,
		minWidth: 160,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: 10,
		cursor: 'pointer',
		fontSize: '0.75rem',
		boxSizing: 'border-box',
		gap: 8,
	},

	/**
	 * Dropdown content inner styling
	 */
	dropdownContentInner: {
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
		maxHeight: 300,
	},

	/**
	 * Individual row within dropdown menus
	 */
	dropdownRow: {
		display: 'flex',
		gap: 8,
		fontSize: 12,
		padding: 4,
		alignItems: 'center',
	},

	/**
	 * Search input group container
	 */
	searchGroup: {
		minWidth: 300, // Making search textbox 100px longer than default
	},

	/**
	 * Search input wrapper styling
	 */
	searchInputWrapper: {
		background: '#FFFFFF',
		minWidth: 280,
		borderRadius: 8,
	},

	/**
	 * Search input field styling
	 */
	searchInput: {
		paddingLeft: 8,
	},

	/**
	 * Search icon styling
	 */
	searchIcon: {
		width: 20,
		height: 20,
		marginRight: 8,
	},

	/**
	 * Clear search button styling
	 */
	clearSearchButton: {
		color: '#0466FF',
		fontSize: 12,
		cursor: 'pointer',
		background: 'none',
		border: 'none',
		padding: 0,
	},

	/**
	 * User count indicator styling
	 */
	userCountIndicator: {
		color: '#666',
		fontSize: 14,
		fontWeight: 500,
		marginLeft: 'auto',
		alignSelf: 'center',
	},
});
